import { render, staticRenderFns } from "./readerFollow.vue?vue&type=template&id=41ebefa9&scoped=true"
import script from "./readerFollow.vue?vue&type=script&lang=js"
export * from "./readerFollow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ebefa9",
  null
  
)

export default component.exports